import {FormCheck} from "react-bootstrap";
import React, {Fragment, useState} from "react";
import {connect} from "react-redux";
import {setIndicator, deleteIndicator, deletePreviousFilter, removePlotPoint} from "../../../actions";
import {FormGroup, Label, Input} from 'reactstrap';

const IndicatorItem = ({Indicators: {active_indicators}, indicator, setIndicator, removePlotPoint,deleteIndicator, deletePreviousFilter}) => {
    const changeState = () => {
        if (active_indicators.includes(indicator.nazwa)) {
            deleteIndicator(indicator.nazwa);
            deletePreviousFilter({[indicator.nazwa]: "all"},"none","12inidicator item")
            removePlotPoint(indicator.nazwa);
        } else {
            setIndicator(indicator.nazwa);
        }
    };
    return (
 <Fragment>

                <FormGroup  style={checkboxStyle} check className='wskaznikiCheckBox'>
                <Label for={indicator.id} check>
                    <Input type="checkbox" name="IdicatorItem" id={indicator.id} onClick={changeState}
                           defaultChecked={active_indicators.includes(indicator.nazwa)} />
                   <span className="form-check-sign"/>
                    {indicator.nazwa}</Label>
                </FormGroup>
            </Fragment>



    );
};
const mapStateToProps = state => ({
    Indicators: state.Indicators

});
const checkboxStyle = {
    "backgroundColor": "#f8f9fa",
}

export default connect(mapStateToProps, {setIndicator, deleteIndicator, deletePreviousFilter,removePlotPoint})(IndicatorItem)